import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentPlan: {
        id: 'twia.quoteandbind.views.payments.paymentPlan',
        defaultMessage: 'Payment Plan: '
    }
});